var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-null-center-img"},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":_vm.toSrc}}),_c('div',{staticStyle:{"color":"#999999"}},[_vm._v("暂无记录")])])])}
var staticRenderFns = []

export { render, staticRenderFns }